/**
 * 该文件中存放，全局公共方法，相当于公共的工具类
 *  引入方法具体参见：bugDetail下的main.js
 *  例如：
 *      // 引用全局方法
 *      import globalFunctions from '../../assets/js/common/GlobalFunction.js'
 *
 *  注意：引入该文件后，本文件中需要被调用的方法，请单独引入
 *    例如：
 *    //引入全局方法文件中本页面需要用到的方法
 *    Vue.prototype.$byUrlInitValue = globalFunctions.$byUrlInitValue
 */
// module.exports = {
export default {
    //根据url初始化vue中的参数，注意：url的格式为：http://localhost:8080/bugDetail?7037&3#/，其中参数部分：7037&3
    "$byUrlInitValue": function (joinStr, vue, propertyNames) {
        let hashStr = decodeURI(location.href);
        if (hashStr != null && hashStr.indexOf("?") >= 0 && hashStr.length > 0 && propertyNames instanceof Array) {
            let startIndex = hashStr.indexOf('?') + 1;
            let endIndex = hashStr.indexOf('#/');
            hashStr = hashStr.substring(startIndex, endIndex);

            let parameters = hashStr.split(joinStr);
            propertyNames.forEach(function (propertyName, propertyNameIndex) {
                if (propertyName != null) {
                    if (propertyName.indexOf(".") >= 0) {
                        let target = null;
                        let deepPropertyNames = propertyName.split(".");
                        deepPropertyNames.forEach(function (filedName, filedNameIndex) {
                            if (target == null) target = vue[filedName];
                            else {
                                if (filedNameIndex == deepPropertyNames.length - 1) {
                                    let value = parameters[propertyNameIndex];
                                    if (value != null && value.length > 0) target[filedName] = value;
                                } else target = target[filedName];
                            }
                        })
                    } else {
                        let value = parameters[propertyNameIndex];
                        if (value != null && value.length > 0) vue[propertyName] = value;
                    }
                }
            })
        }
    },
    valNullHandler,
    textToHtmlHandler,
    baseForm,
    baseListForm,
    uploadFile,
    jumpToPersonCenter,
    logout,
    adminLogout,
    countDown,
    getProjectMemberRole,
    showLoading,
    dismissLoading,
    checkStorageSpace,
    getStorageSpaceCanUse
}

import $api from "./ServerInterface";
import {
    Loading,
} from 'element-ui';

/**
 * 空值处理（方法），解决向v-html这样的指令中无法使用“|”过滤器的问题
 */
function valNullHandler(value, placeholder)
{
    if (value == null || (value+"").length < 1) return placeholder ? placeholder:" -- ";
    else return value;
}

/**
 * 换行符转义
 */
function textToHtmlHandler(value, placeholder)
{
    if (value == null || (value+"").length < 1)
    {
        return placeholder ? placeholder:" -- ";
    }
    else
    {
        let val = value
            .replace(/\n/g,'<br/>')
            .replace(/\t/g,'&nbsp;&nbsp;&nbsp;&nbsp;');
        return val;
    }
}

function baseForm(mInterfaceVersion) {
    var interfaceVersion = undefined
    if (mInterfaceVersion == undefined) {
        interfaceVersion = 19000101
    } else {
        interfaceVersion = mInterfaceVersion
    }

    return {
        interfaceVersion: interfaceVersion,
        pageNumber: this.pageNumber,
        countPerPage: this.countPerPage,
        totalPage: this.totalPage,
        keyword: this.keyword,
        startTimeStr: this.startTimeStr,
        endTimeStr: this.endTimeStr,
        timeType: this.timeType,
        memberId: this.memberId,
        theState: this.theState,
    }
}

function baseListForm(mPageNum, mCountPerPage, mKeyword, mInterfaceVersion) {
    var interfaceVersion
    var pageNum
    var countPerPage
    var keyword

    if (mInterfaceVersion == undefined) {
        interfaceVersion = 19000101
    } else {
        interfaceVersion = mInterfaceVersion
    }
    if (mPageNum == undefined) {
        pageNum = 0
    } else {
        pageNum = mPageNum
    }
    if (mCountPerPage == undefined) {
        countPerPage = 0
    } else {
        countPerPage = mCountPerPage
    }
    if (mKeyword == undefined) {
        keyword = undefined
    } else {
        keyword = mKeyword
    }

    return {
        interfaceVersion: interfaceVersion,
        pageNumber: pageNum,
        countPerPage: countPerPage,
        keyword: keyword,

    }
}

//上传文件
function uploadFile(e, onUploadSuccess) {
    //上传文件
    var this_ = this;
    let formData = new FormData();
    formData.append("uploadFile", e.target.files[0]);
    formData.append('interfaceVersion', 19000101);
    formData.append('memberToken', localStorage.getItem("memberToken"));
    $api.post('/smSingleFileUpload.smhtml', formData, jsonObj => {
        console.info(jsonObj);
        //GlobalData.API_SERVICE_SERVER_BASE_URL+jsonObj.filePath;
        e.target.value = "";

        onUploadSuccess(jsonObj, jsonObj.filePath)
        // importInfo(this_, jsonObj.filePath);
    }, jsonObj => {
        //this.$message.error(jsonObj.info);
        console.info(jsonObj);
        e.target.value = "";
    }, function () {
        e.target.value = "";
    })
}

function jumpToPersonCenter(memberId) {
    window.location.href = `personalCenter.html?${memberId}`
}

//退出
function logout(vue) {
    let form = {
        interfaceVersion: 19000101
    }
    $api.defaultPost('/smMemberLoginOut.smhtml', form, jsonObj => {
        localStorage.removeItem("memberName")
        localStorage.removeItem("headImagePath")
        localStorage.removeItem("firstLetter")
        localStorage.removeItem("email")
        localStorage.removeItem("memberId")
        localStorage.removeItem("phoneNumber")
        localStorage.removeItem("memberToken")
        localStorage.removeItem("socketioUserToken")
        localStorage.removeItem("memberLoginToken")
        window.location.href = "login.html"
    })
}

//管理员退出
function adminLogout(vue) {
    let form = {
        interfaceVersion: 19000101
    }
    $api.defaultPost('/saAdminLoginOut.sahtml', form, jsonObj => {
        localStorage.removeItem("adminName")
        localStorage.removeItem("adminHeadImagePath")
        localStorage.removeItem("adminFirstLetter")
        localStorage.removeItem("adminEmail")
        localStorage.removeItem("adminId")
        localStorage.removeItem("adminPhoneNumber")
        localStorage.removeItem("adminToken")
        window.location.href = "../superAdmin/login.html"
    })
}

function countDown(vue) {
    const TIME_COUNT = 60;
    if (!vue.timer) {
        vue.wait = TIME_COUNT;
        vue.timer = setInterval(() => {
            if (vue.wait > 0 && vue.wait <= TIME_COUNT) {
                vue.$refs.code.setAttribute("disabled", true)
                vue.count= vue.wait + "s";
                vue.wait--;
                // console.log(vue.$refs.yzm)
            } else {
                vue.$refs.code.removeAttribute("disabled");
                clearInterval(vue.timer);
                vue.timer = null;
            }
        }, 1000)
    }
}

//校验存储空间的使用情况
function checkStorageSpace(vue,thenFun,failFun) {
    let form = {
        interfaceVersion: 19000101,
        projectId:vue['projectId'],
        fileSize:vue['fileSize'],
    }
    $api.post('/smProjectMemberCheckStorageSpace.smhtml', form, jsonObj => {
        if(thenFun !== null && thenFun !== undefined) thenFun();
    },jsonObj => {
        // console.log(jsonObj);
        if(failFun !== null && failFun !== undefined) failFun(jsonObj);
    })
}

//获取存储空间的可用情况
function getStorageSpaceCanUse(vue,thenFun) {
    let form = {
        interfaceVersion: 19000101,
        projectId:vue['projectId'],
    }
    $api.defaultPost('/smProjectMemberGetStorageSpaceCanUse.smhtml', form, jsonObj => {
        vue['isBuyPackage'] = jsonObj.isBuyPackage;
        vue['isInvalid'] = jsonObj.isInvalid;
        vue['storageSpaceIsUnlimited'] = jsonObj.isUnlimited;
        vue['canUseStorageSpace'] = jsonObj.canUseStorageSpace;

        if(thenFun !== null && thenFun !== undefined) thenFun();
    })
}

//获取项目中登录者的角色
function getProjectMemberRole(vue,thenFun) {
    let form = {
        interfaceVersion: 19000101,
        projectId:vue['projectId']
    }
    $api.defaultPost('/smProjectMemberRole.smhtml', form, jsonObj => {
        vue['role'] = jsonObj.role;
        if(thenFun !== null && thenFun !== undefined) thenFun();
    })
}

function showLoading(msg) {
    let loadingInstance = Loading.service({
        lock: true,
        text: msg,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    return loadingInstance
}

function dismissLoading(loadingInstance) {
    loadingInstance.close()
}
